import React from "react"

import { Card, CardItem, Skeleton } from "@walmart-web/livingdesign-components"

type columnTypes = "table-data" | "table-data-bar"
interface InformationTableSkeletonProps {
	columns?: Array<columnTypes>
	rows?: number
}

const defaultColumns: Array<columnTypes> = [
	"table-data",
	"table-data-bar",
	"table-data",
	"table-data",
]
const InformationTableSkeleton: React.FC<InformationTableSkeletonProps> = (
	props
) => {
	const { columns = defaultColumns, rows = 6 } = props

	const records = Array.from({ length: rows }, (x, index) => index)
	return (
		<Card role="skeletonview" className="skeleton-container">
			<CardItem className="card-item">
				<div className="card-header">
					<div className="table-header table-row">
						{columns.map((type, index) => (
							<Skeleton
								key={`column-header-${index}`}
								className={type}
								variant="rounded"
							/>
						))}
					</div>
				</div>

				<div className="card-body">
					{records.map((element) => {
						return (
							<div key={element} className="table-row">
								{columns.map((type, index) => (
									<Skeleton
										key={`row-${index}`}
										className={type}
										variant="rounded"
									/>
								))}
							</div>
						)
					})}
				</div>
			</CardItem>
		</Card>
	)
}

export default InformationTableSkeleton
